export default "__VITE_ASSET__CiM4jk8u__"